import React from 'react'
import { connect } from 'react-redux'
import { Layout } from 'antd'
import { withRouter } from 'react-router-dom'
import classNames from 'classnames'
/* import Sidebar from '@airui/layout/Sidebar'
import SupportChat from '@airui/layout/SupportChat' */
import style from './style.module.scss'

const mapStateToProps = ({ settings }) => ({
  isGrayTopbar: settings.isGrayTopbar,
  isCardShadow: settings.isCardShadow,
  isSquaredBorders: settings.isSquaredBorders,
  isBorderless: settings.isBorderless,
  authPagesColor: settings.authPagesColor,
  /* logo: settings.logo,
  description: settings.description, */
})

const AuthLayout = ({
  children,
  isCardShadow,
  isSquaredBorders,
  isBorderless,
  authPagesColor,
  /* logo,
  description, */
}) => {
  return (
    <Layout style={{background:'#FFFFFF'}}>
      <Layout.Content>
        {/*  <Sidebar />
        <SupportChat /> */}
        <div
          style={{background:'#FFFFFF'}}
          className={classNames(`${style.container}`, {
            air__layout__squaredBorders: isSquaredBorders,
            air__layout__cardsShadow: isCardShadow,
            air__layout__borderless: isBorderless,
            [style.white]: authPagesColor === 'white',
            [style.gray]: authPagesColor === 'gray',
          })}
        >
          {/* <div className="pt-5 pb-5 d-flex align-items-end mt-auto">
            <a href="#" onClick={e => e.preventDefault()} className={style.logo}>
              <div className={style.logo__letter}>A</div>
              <div className={style.logo__name}>{logo}</div>
              <div className={style.logo__descr}>{description}</div>
            </a>
          </div> */}
          <div className="row">
            <div
              className="col-lg-8"
              style={{
                backgroundImage:
                  'url("resources/images/loginBackground.png")',
                backgroundSize: 'cover',
                backgroundRepeat: 'no-repeat',
                backgroundPosition: 'top center',
                // height: 'auto',
                height:'100vh'
              }}
            />
            <div className="col-lg-4">
              {children}
            </div>
          </div>
          {/* <div className={style.containerInner}>{children}</div> */}
          {/* <div className="mt-auto pb-5 pt-5">
            <ul
              className={`${style.footerNav} list-unstyled d-flex mb-0 flex-wrap justify-content-center`}
            >
            </ul>
          </div> */}
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default withRouter(connect(mapStateToProps)(AuthLayout))
